<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card w-100">
            <!-- Title, filters and the page actions share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Active Alarms</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <div class="input-wrapper">
                        <ng-select [items]="allPlantList" bindLabel="stationName" placeholder="Plant"
                            bindValue="stationCode" class="limit-ng-value sb-filter-field sb-filter-field--md"
                            (change)="selectPlants($event)">
                        </ng-select>
                    </div>
                    <div class="input-wrapper">
                        <ng-select [items]="regionList" bindLabel="name" placeholder="Region" bindValue="id"
                            class="limit-ng-value sb-filter-field sb-filter-field--md"
                            (change)="selectedRegion($event)">
                        </ng-select>
                    </div>
                    <div class="input-wrapper">
                        <ng-select [items]="severityLevels" bindLabel="name" placeholder="Alarms Severity"
                            bindValue="id" class="limit-ng-value sb-filter-field sb-filter-field--md"
                            (change)="selectedSeverity($event)">
                        </ng-select>
                    </div>
                    <div class="btn-group sb-filter-search-group" role="group">
                        <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                            (input)="searchData($event)">
                        <button type="button" class="btn sb-filter-search-btn">
                            <!-- <i class="ri-search-line"></i> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none">
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <button class="btn btn-dark rounded" (click)="downloadReport()" [disabled]="isDownloading"
                    *ngIf="permissionsReady && permissions.canView">
                    <ng-container *ngIf="!isDownloading">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                            class="me-2">
                            <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Download
                    </ng-container>
                    <ng-container *ngIf="isDownloading">
                        <span class="spinner-border spinner-border-sm align-middle me-2"></span>
                        Downloading
                    </ng-container>
                </button>
            </div>
            <div class="table-wrap" [class.is-loading]="tableLoader">
                <div class="loaderwrapper" *ngIf="tableLoader">
                    <span class="loader"></span>
                </div>
                <!-- (activate)="onActivate($event,ticketDetail)" -->
                <ngx-datatable #myTable [style.width]="'100%'" class="material expandable table-responsive" [rows]="row"
                    [headerHeight]="50" [footerHeight]="0" [columnMode]="'force'" [scrollbarH]="true"
                    [rowHeight]="'auto'" [offset]="0" [externalSorting]="true"
                    [messages]="{emptyMessage: 'No Alarm found.'}" *ngIf="permissionsReady && permissions.canView"
                    (sort)="onSort($event)">
                    <ngx-datatable-column [sortable]="false" [maxWidth]="60"
                        *ngIf="permissionsReady && permissions.canDelete">
                        <!-- Checkbox in the column header -->
                        <ng-template ngx-datatable-header-template let-column="column" let-sort="sortFn">
                            <div>
                                <label class="custom-checkbox large">
                                    <input type="checkbox" [checked]="columnCheckboxSelected"
                                        (change)="toggleAllRows($event.target.checked)" />
                                    <span class="checkbox-item"></span>
                                </label>
                            </div>
                        </ng-template>

                        <!-- Checkbox in each row -->
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <label class="custom-checkbox large">
                                <input type="checkbox" class="checkbox-item" [checked]="row.selected"
                                    (change)="toggleRowSelection(row)" />
                                <span class="checkbox-item"></span>
                            </label>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Alarm ID" prop="id" [maxWidth]="100">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.id">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{row.alarmId}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Plant Name" prop="stationName">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('stationName')">
                                Station Name
                                <span class="sort-btn"
                                    [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'stationName',
                                          'datatable-icon-up': sortColumn === 'stationName' && sortOrder === 'asc',
                                          'datatable-icon-down': sortColumn === 'stationName' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px">
                                <span>{{ row.stationName }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Alarm Severity" prop="alarmSeverity">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.alarmSeverity">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{ row.alarmSeverity }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" name="Alarm Name" prop="alarmName">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('alarmName')">
                                Alarm Name
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'alarmName',
                                        'datatable-icon-up': sortColumn === 'alarmName' && sortOrder === 'asc',
                                        'datatable-icon-down': sortColumn === 'alarmName' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>{{ row.alarmName }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Dev Name" prop="devName">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('devName')">
                                Dev Name
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'devName',
                                          'datatable-icon-up': sortColumn === 'devName' && sortOrder === 'asc',
                                          'datatable-icon-down': sortColumn === 'devName' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>{{ row.devName }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Occurrence Time" prop="occurrenceTime">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                            let-value="row.occurrenceTime">
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>
                                {{ row.occurrenceTime }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Status" prop="status">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('status')">
                                Status
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'status',
                                          'datatable-icon-up': sortColumn === 'status' && sortOrder === 'asc',
                                          'datatable-icon-down': sortColumn === 'status' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>{{ row.status }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [sortable]="false" name="Esn Code" prop="esnCode">
                        <ng-template ngx-datatable-header-template let-column="column">
                            <a class="cursor-pointer" (click)="sortAlarms('esnCode')">
                                Esn Code
                                <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'esnCode',
                                          'datatable-icon-up': sortColumn === 'esnCode' && sortOrder === 'asc',
                                          'datatable-icon-down': sortColumn === 'esnCode' && sortOrder === 'desc'}">
                                </span>
                            </a>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="form-group" style="margin-bottom: 0px"></div>
                            <span>{{ row.esnCode }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Actions" [sortable]="false" [minWidth]="110"
                        *ngIf="permissionsReady && (permissions.canView || permissions.canDelete)">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex align-items-center gap-2">
                                <!-- View -->
                                <button type="button" class="btn btn-icon" title="View"
                                    (click)="onView(row, ticketDetail)" *ngIf="permissions.canView">
                                    <svg width="15" height="11" viewBox="0 0 15 11" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.49995 11C4.43219 11 1.84977 8.32414 0.583562 6.72892C0.244785 6.3019 0 5.99302 0 5.5C0 5.00698 0.244785 4.6981 0.583138 4.27108C1.84977 2.67586 4.43219 0 7.49995 0C10.5693 0 13.1507 2.67586 14.4163 4.27108C14.7547 4.6981 15 5.00698 15 5.5C15 5.99302 14.7552 6.3019 14.4169 6.72892C13.1508 8.32414 10.5693 11 7.49995 11ZM7.49995 1.1C4.86687 1.1 2.54883 3.52506 1.40121 4.97046C1.14296 5.29595 1.05967 5.40925 1.05967 5.5C1.05967 5.59075 1.14296 5.70405 1.40174 6.02954C2.54883 7.47494 4.86687 9.9 7.49995 9.9C10.2324 9.9 12.6752 7.19356 13.5988 6.02954C13.857 5.70405 13.9403 5.59075 13.9403 5.5C13.9403 5.40925 13.857 5.29595 13.5988 4.97046C12.6752 3.80644 10.2325 1.1 7.49995 1.1ZM7.49995 8.9375C5.67402 8.9375 4.18847 7.39541 4.18847 5.5C4.18847 3.60459 5.67402 2.0625 7.49995 2.0625C9.32587 2.0625 10.8114 3.60459 10.8114 5.5C10.8114 7.39541 9.32598 8.9375 7.49995 8.9375ZM7.49995 3.1625C6.25812 3.1625 5.24814 4.21091 5.24814 5.5C5.24814 6.78909 6.25812 7.8375 7.49995 7.8375C8.74178 7.8375 9.75175 6.78909 9.75175 5.5C9.75175 4.21091 8.74178 3.1625 7.49995 3.1625Z"
                                            fill="currentColor" />
                                    </svg>
                                </button>

                                <!-- Clear -->
                                <button class="btn btn-dark btn-circle" title="Clear" 
                                [disabled]="row.clearButtonDisabled" *ngIf="permissions.canDelete" (click)="onClear()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                        fill="none">
                                        <path d="M7.59808 6.8053L10.8885 10.0957L14.1789 6.8053" stroke="currentColor"
                                            stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.59809 13.7562L10.8879 10.4658L14.1783 13.7562" stroke="currentColor"
                                            stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>
                <div *ngIf="permissionsReady && !permissions.canView" class="no-access text-center p-4">
                    You don’t have permission to view this data.
                </div>
                <div class="table-meta">
                    <div class="entries flex-column align-items-start gap-3">
                        <label class="show-entries-list p-0">
                            Show
                            <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                (change)="changePageSize()">
                                <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                    {{ limit.label }}
                                </option>
                            </select>
                            Entries
                        </label>
                        <span>Total Records: {{this.total_items }}</span>
                    </div>
                    <nav class="table-pagination">
                        <ul>
                            <li>
                                <div class="go-to-page d-flex align-items-center">
                                    <label>Go to Page:</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                        min="1" [max]="total_pages"
                                        (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                    <div class="input-group-append">
                                        <button class="btn btn-primary" type="button"
                                            (click)="goToPage(pageToGo); pageToGo = null"
                                            [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                    </div>
                                </div>
                            </li>
                            <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                    [class.disabled]="current_page === 1">1</a></li>
                            <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                        class="fa fa-chevron-left"></i></a></li>
                            <li><a class="active">{{ current_page }}</a></li>
                            <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                    [class.disabled]="current_page === total_pages"><i
                                        class="fa fa-chevron-right"></i></a>
                            </li>
                            <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                    [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                        </ul>
                    </nav>

                </div>

            </div>
        </div>
        <div class="loaderwrapper" *ngIf="loader">
            <span class="loader"></span>
        </div>
    </div>
</section>

<ng-template #ticketDetail let-c="close" let-d="dismiss" let-width="500">
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Alarm</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>


        <div class="modal-body">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <!-- <th scope="col">ID</th> -->
                        <th scope="col">Station Name</th>
                        <th scope="col">Station Code</th>
                        <th scope="col">Occurrence Time</th>
                        <th scope="col">Device Name</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{{ this.alarmDetailsItem.stationName }}</td>
                        <td>{{ this.alarmDetailsItem.stationCode }}</td>
                        <td>{{ this.alarmDetailsItem.occurrenceTime }}</td>
                        <td>{{ this.alarmDetailsItem.devName }}</td>
                    </tr>
                </tbody>
            </table>

            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Alarm Id</th>
                        <th scope="col">Alarm Severity</th>
                        <th scope="col">Alarm Name</th>
                        <th scope="col">Alarm Cause</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{{ this.alarmDetailsItem.alarmId }}</td>
                        <td>{{ this.alarmDetailsItem.alarmSeverity }}</td>
                        <td>{{ this.alarmDetailsItem.alarmName }}</td>
                        <td>{{ this.alarmDetailsItem.alarmCause }}</td>
                    </tr>
                </tbody>
            </table>

            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">status</th>
                        <!-- <th scope="col">Occurrence Time</th> -->
                        <th scope="col">Cause Id</th>
                        <th scope="col">Esn Code</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <!-- <td>{{ alarmInfo.devTypeId }}</td> -->
                        <td>{{ alarmDetailsItem.status }}</td>
                        <td>{{ alarmDetailsItem.causeId }}</td>

                        <td>{{ alarmDetailsItem.esnCode }}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <!-- <th scope="col">Alarm Cause</th> -->
                        <th scope="col">Suggestion</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <!-- <td>{{ alarmInfo.alarmCause }}</td> -->
                        <td>{{ alarmDetailsItem.suggestion }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</ng-template>